import { ComponentProps } from "react";

import { useColorModeValue } from "@/providers/ThemeProvider";
import { useCurrentUser } from "@/providers/UserProvider";

import UserAvatar from "../elements/UserAvatar";

export function CurrentUserAvatar(
  props: Omit<
    ComponentProps<typeof UserAvatar>,
    "backgroundColor" | "firstName" | "lastName"
  >,
) {
  const user = useCurrentUser();
  const backgroundColor = useColorModeValue("#0ea5e9", "#0369a1");
  return (
    <UserAvatar
      firstName={user.firstName}
      lastName={user.lastName}
      backgroundColor={backgroundColor}
      {...props}
    />
  );
}
